import { Avatar, Input, List, ListItem, ListItemAvatar, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { Box } from "@mui/system";
import { useEffect } from "react";
import { useState } from "react";
import EditableBox from "../../edit/EditableBox";
import { EditableList } from "../../edit/EditableList";
import allAdminRoles from "../../../constants/allAdminRoles"
import useFetchJson from "../../../data/useFetchJson";

const LocalStyledList = styled(List)(({theme}) => ({
  display: 'inline-block',
  paddingRight: '2em',
  ':hover': {
      background: '#f1f3f5',
      cursor: 'text',
  }
}));

/**
 * Editable form for user details: name, email, phone, roles[]
 * @param {userDetails:{*}, userChanged:Function}  
 * @returns 
 */
export function EditUserForm({userDetails, userChanged}) {

    const [user, setUser] = useState({...userDetails})

    const noContractorLabel = '-- no contractor --'

    const {
        data: allAccounts, // [{"accountId": "0017F00000tmP1MQAU", "name": "Northpower Contracting", "email": "contracting@northpower.com", "phone": "021 432234" }, ...]
    } = useFetchJson('/bff/user-management-service-mahi/api/accounts/all', {}, true)

    useEffect(() => {
        if (userChanged && typeof(userChanged) === 'function') {
          userChanged({...user})
        }
    // (linter is worried about onUserChange but it's an output function)
    // eslint-disable-next-line 
    }, [user])


    const handleNameChange = (event) => {
      const updatedUser = {...user, name: event.target.value}
      setUser(updatedUser)
    }

    const handleEmailChange = (event) => {
      const updatedUser = {...user, email: event.target.value}
      setUser(updatedUser)
    }

    const handlePhoneChange = (event) => {
      const updatedUser = {...user, phone: event.target.value}
      setUser(updatedUser)
    }

    const handleAccountChange = (event) => {
      const updatedUser = {...user}
      if (event.target.value && event.target.value !== noContractorLabel) {
        updatedUser.account = allAccounts.find(a => a.name === event.target.value)
      } else {
        // user selected "-- no account --"
        updatedUser.account = null
      }
      setUser(updatedUser)
    }

    const handleRolesChange = (roles) => {
      const updatedUser = {...user, roles}
      setUser(updatedUser)
    }

    const handleEditRolesCancel = () => {
      setUser({...userDetails}) // restore user back to original
    }

    const handleEditRolesDone = () => {
      console.log(`handleEditRolesDone()`)
    }

    return (
        <Box>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Avatar alt="Edit User" />
                </ListItemAvatar>
                <Stack direction="column">
                  <Input value={user.name} type="text" placeholder="Name" onChange={handleNameChange} sx={{width: '310px', mb: 2}}/>
                  <Input value={user.email} type="email" placeholder="Email" onChange={handleEmailChange} sx={{width: '310px', mb: 2}} />
                  <Input value={user.phone} type="text" placeholder="Phone" onChange={handlePhoneChange} sx={{width: '310px', mb: 2}} />

                  <TextField
                    select
                    defaultValue={user?.account?.name}
                    label="Contractor"
                    onChange={handleAccountChange}
                    sx={{width: '100%', mb: 2}}
                  >
                    <MenuItem key={noContractorLabel} value={noContractorLabel}>{noContractorLabel}</MenuItem>
                    {
                      allAccounts?.length > 0
                      &&
                      allAccounts.map(({accountId, name}) => {
                        return (
                          <MenuItem key={accountId} value={name}>
                            {name}
                          </MenuItem>
                        )
                      })
                    }
                    </TextField>

                  <EditableBox
                      onCancel={handleEditRolesCancel}
                      onDone={handleEditRolesDone}
                      edit={<EditAdminRoles roles={user.roles} onAdminRolesChange={handleRolesChange} />}
                    >
                    <LocalStyledList>
                    {
                        (user.roles || []).map((thisRole) => {
                            return (
                                <ListItem dense={true} sx={{px: 1}} key={thisRole}>
                                    <Typography variant="body2">{thisRole}</Typography>
                                </ListItem>
                            )
                        })
                    }
                    </LocalStyledList>
                  </EditableBox>
                </Stack>
            </ListItem>
            {/* <DebugBox title="user" stringify>{user}</DebugBox>
            <DebugBox title="allAccounts" stringify>{allAccounts}</DebugBox> */}
        </Box>
    )
}

/**
 * 
 * @param {roles:String[], onAdminRolesChange:Function} param0 
 * @returns 
 */
function EditAdminRoles({roles, onAdminRolesChange}) {

  const [newroles, setRoles] = useState(roles)

  useEffect(() => {
    if (onAdminRolesChange && typeof(onAdminRolesChange) === 'function') {
      console.log(`calling onAdminRolesChange()`, {...newroles})
      onAdminRolesChange([...newroles])
    }
// (linter is worried about onUserChange but it's an output function)
// eslint-disable-next-line 
}, [newroles])

  const handleListChange = (newRoles) => {
    console.log('handleListChange', newRoles)
    // if (onAdminRolesChange && typeof(onAdminRolesChange) === 'function') {
    //     onAdminRolesChange(newRoles)
    // }
    setRoles([...newRoles])
  }

  return (
    <EditableList list={newroles} selectFrom={allAdminRoles} placeholder="Add a new role" onListChange={handleListChange} />
  )
}